// extracted by mini-css-extract-plugin
export default {"imageContainer":"w3-z","summaryPar":"x3-z","ratingCategories":"y3-z","reviewerInfo":"z3-z","reviewTypes":"A3-z","expanded":"B3-z"};